import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../shared/BreadCrumb";
import { useStepType } from "../../../../utils/type";
import { useStep } from "react-hooks-helper";
import PanierValidStep from "./steps/PanierValidStep";
import AdresseLivraison from "./steps/AdresseLivraison";
import UseAddOrUpdateOrderForm from "./requestForm/UseAddOrUpdateOrderForm";
import { useAppSelector } from "../../../../redux/hook";
import ConnexionModal from "../../../shared/FrontHeader/modal/ConnexionModal";
import { useGetVendeurByApiKeyQuery } from "../../../../utils/api/product/product.api";
import { VendeurApikey } from "../../../../utils/http";
import { formatCurrency } from "../../../../utils/Utils";

const steps = [
  { id: "panier-validation", Component: PanierValidStep },
  { id: "informations-paiement", Component: AdresseLivraison },
];
const tabs = ["1", "2"];

function ValidateCommand() {
  const { user } = useAppSelector((s) => s?.user);
  const { data: vendeur } = useGetVendeurByApiKeyQuery(VendeurApikey);
  const [modalConnexion, setModalConnexion] = useState(false);
  const { cartItems, totalAmount } = useAppSelector((state) => state.cart);

  const {
    step,
    navigation: { next, previous },
    index,
  }: useStepType = useStep({ initialStep: 0, steps });
  const { Component } = step;

  const {
    register,
    onSubmit,
    isLoading,
    errors,
    handleChangePhone,
    phone,
    onChangeAdresse,
    adresse,
    setValue,
  } = UseAddOrUpdateOrderForm(next, previous);

  useEffect(() => {
    if (user?.id) {
      setValue("telephone", user?.telephone);
      setValue("adresse", user?.adresse);
      setValue("user", user?.id);
    }
  }, [user, setValue]);

  useEffect(() => {
    const code_commande: number | string = new Date().getTime();
    setValue("code_commande", code_commande.toString());
    // Par défaut : paiement à la livraison (souvent le seul moyen)
    setValue("mode_de_paiement", "CASH");
  }, [setValue]);

  // Quand on arrive sur l'étape infos/paiement, activer la validation step 2
  useEffect(() => {
    if (index >= 1) {
      setValue("step", 2);
      setValue("mode_de_paiement", "CASH");
    } else {
      setValue("step", 1);
    }
  }, [index, setValue]);

  useEffect(() => {
    const produitVisiteur = cartItems?.map((x) => ({
      produit: x?.produit?.id || x?.produit,
      prix: x?.prix > 0 ? x?.prix : undefined,
      quantite: x?.quantite,
      variations: x?.variations?.map((v) => v?.id).filter((id) => id != null),
    }));

    setValue("vendeur", cartItems[0]?.vendeur);
    setValue("produits", produitVisiteur);
    setValue("montant_total", totalAmount);
  }, [cartItems, setValue, totalAmount]);

  const goToInfos = () => {
    setValue("step", 2);
    setValue("mode_de_paiement", "CASH");
    next();
  };

  const precedent = () => {
    setValue("step", 1);
    previous();
  };

  return (
    <div className="landing-page-component">
      <div className="page-content pb-5 pb-5">
        <div className="container pt-4">
         <BreadCrumb pageName="Panier" secondPage="Informations" showHome={false} />

          <h1 className="cart-page-title pt-4">Mon panier</h1>
            {index > 0 && (
          <button type="button" className="retour-panier-link" onClick={precedent}>
            ← Retour au panier
          </button>
            )}
          {cartItems.length === 0 ? (
            <div className="empty-cart-box mt-4">
              <p>
                Votre panier est vide. Découvrez notre sélection de produits
                naturels.
              </p>
              <a href="/produits" className="btn-voir-produits">
                Voir nos produits
              </a>
            </div>
          ) : (
            <div className="validate-command-content pt-5 pb-5">
              <div className="row row-validate">
                <div className="col-lg-9 validate-wrapper">
                 <form onSubmit={onSubmit} id="validate-form">

<Component
  register={register}
  errors={errors}
  handleChangePhone={handleChangePhone}
  phone={phone}
  vendeur={vendeur}
  onChangeAdresse={onChangeAdresse}
  adresse={adresse}
  totalAmount={totalAmount}
/>

                    {index === 1 && (
                      <div className="action-btn-content pt-4">
                        <button
                          className="btn-confirmer-commande-lg"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading
                            ? "Validation ..."
                            : `Confirmer la commande — ${formatCurrency(
                                totalAmount,
                                vendeur?.devise
                              )}`}
                        </button>
                      </div>
                    )}
                  </form>
                </div>

                <div className="col-lg-3">
                  <div className="cart-card">
                    <h1 className="title pb-3">Récapitulatif</h1>
                    <div className="separator mb-3"></div>

                    {cartItems.map((item) => {
                      const produitId =
                        typeof item?.produit === "string"
                          ? item.produit
                          : item?.produit?.id;
                      const produitNom =
                        typeof item?.produit === "string"
                          ? ""
                          : item?.produit?.nom;

                      return (
                        <div
                          key={`${produitId}-${
                            item?.variations?.[0]?.id ?? "u"
                          }`}
                          className="recap-line d-flex justify-content-between align-items-center py-2"
                        >
                          <span className="recap-label">
                            {produitNom}{" "}
                            <span className="recap-qty">
                              ×{item?.quantite}
                            </span>
                          </span>
                          <span className="recap-price">
                            {formatCurrency(
                              (item?.prix || 0) * (item?.quantite || 1),
                              vendeur?.devise
                            )}
                          </span>
                        </div>
                      );
                    })}

                    <div className="separator my-3"></div>

                    <div className="total d-flex align-items-center justify-content-between pt-2">
                      <span className="sm-title">Total</span>
                      <span className="sm-value total">
                        {formatCurrency(totalAmount, vendeur?.devise)}
                      </span>
                    </div>

                    {index === 0 ? (
                      <button
                        type="button"
                        className="btn-passer-commande mt-4"
                        onClick={goToInfos}
                      >
                        Passer la commande →
                      </button>
                    ) : (
                      <button
                        type="submit"
                        form="validate-form"
                        className="btn-passer-commande mt-4"
                        disabled={isLoading}
                      >
                        {isLoading ? "Validation ..." : "Confirmer la commande"}
                      </button>
                    )}

                    <a  href="/produits"
                      className="continuer-achats mt-3 d-block text-center"
                    >
                      ← Continuer mes achats
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <ConnexionModal
        modalConnexion={modalConnexion}
        setModalConnexion={setModalConnexion}
      />

      {cartItems.length > 0 && (
        <div className="mobile-bottom-bar">
          <div>
            <div className="total-label">Total</div>
            <div className="total-amount">
              {formatCurrency(totalAmount, vendeur?.devise)}
            </div>
          </div>
          <div className="bnt-section">
            {index === 0 && (
              <button
                className="step-action-btn parcours-submit-btn"
                type="button"
                onClick={goToInfos}
              >
                Suivant →
              </button>
            )}
            {index > 0 && (
              <button
                className="step-action-btn parcours-submit-btn"
                type="submit"
                form="validate-form"
                disabled={isLoading}
              >
                {isLoading ? "Validation ..." : "Confirmer →"}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ValidateCommand;